<script>
import { Value } from '../../../model/ModelUtil'

export default {
  name: 'skillScoreBar',
  computed: {
    Value () {
      return Value
    },
  },
  props: {
    skills: {
      type: Array,
    },
    label: {
      type: String,
    },
    prop: {
      type: Array,
      required: false,
    },
    haveInput: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data () {
    return {
      localSkills: [],
      form: {
        score: null,
        improvable: false,
      },
    }
  },
  watch: {
    skills (newSkill) {
      this.localSkills = newSkill
      const item = newSkill.filter((item) => {
        return item.name === this.label
      })
      if (item[0]) {
        this.form.score = item[0].score
        this.form.improvable = item[0].improvable
      }
    },
  },
  methods: {
    changeSkill () {
      this.localSkills = [...this.skills]
      this.localSkills = this.localSkills.filter((item) => {
        return item.name !== this.label
      })
      this.localSkills.push({
        name: this.label,
        score: this.form.score,
        improvable: this.form.improvable,
      })
      this.$emit('update:skills', this.localSkills)
    },
  },
}
</script>

<template>
  <el-form-item style="margin-bottom: 52px;">
    <span class="text" slot="label">{{ Value.skill.fromValue(label) }}</span>
    <div class="score-container">
      <input
        v-for="n in 11" :key="`${label}-ip-${n}`"
        type="radio"
        :id="`${label}-option-${n}`"
        :value="n - 1"
        v-model="form.score"
        v-on:change="changeSkill"
      >
      <label
        v-for="n in 11" :key="`${label}-op-${n}`"
        :for="`${label}-option-${n}`"
        :class="{ 'selected': form.score === n - 1 }"
      >
        {{ !(n - 1) ? '-' : n - 1 }}
      </label>
    </div>
    <el-checkbox
      v-model="form.improvable"
      v-on:change="changeSkill"
    >
      <span class="improvable">เพิ่มทักษะได้</span>
    </el-checkbox>
  </el-form-item>
</template>

<style scoped lang="scss">
  .text {
    color: #434B61;
    font-size: 18px;
    font-weight: 400;
    line-height: 2.2;
  }

  .improvable {
    margin-left: -2px;
    color: #434B61;
    font-family: "Sukhumvit-Medium";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 300%;
  }

  .score-container {
    display: flex;
    flex-direction: row;
    gap: 12px;

    input {
      display: none;
    }

    label {
      width: 40px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      border: 1px solid #D5D6DB;
      background-color: #FFFFFF;
      color: #D5D6DB;
      font-family: 'Sukhumvit-SemiBold';
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      transition-duration: .3s;
      cursor: pointer;

      &:hover {
        color: #5489FF;
        border: 1px solid #D5D6DB;
        background-color: #EDF3FF;
      }

      &.selected {
        color: #5489FF;
        border: 1px solid #5489FF;
        background-color: #EDF3FF;
      }
    }
  }
</style>
